/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M345.91 468.86C317.45 480.9 287.2 487 256 487c-31.2 0-61.45-6.1-89.91-18.14-27.5-11.64-52.21-28.3-73.43-49.52-21.22-21.22-37.88-45.93-49.52-73.43C31.1 317.45 25 287.2 25 256c0-31.2 6.1-61.45 18.14-89.91 11.64-27.5 28.3-52.21 49.52-73.43 21.22-21.22 45.93-37.88 73.43-49.52C194.55 31.1 224.8 25 256 25c31.2 0 61.45 6.1 89.91 18.14 27.5 11.64 52.21 28.3 73.43 49.52 21.22 21.22 37.88 45.93 49.52 73.43C480.9 194.55 487 224.8 487 256c0 31.2-6.1 61.45-18.14 89.91-11.64 27.5-28.3 52.21-49.52 73.43-21.22 21.22-45.93 37.88-73.43 49.52M256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconNotVerified = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconNotVerified.defaultProps = {
  theme,
};
IconNotVerified.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconNotVerified.displayName = 'IconNotVerified';
export { IconNotVerified };
